import { useTranslation } from "react-i18next";
import VestelIcon from "../../atoms/images/VestelIcon";

const MobileLogo = () => {
  const { t } = useTranslation();

  return (
    <div className="max-[767px]:flex md:hidden w-full p-4 items-center justify-center h-[120px] relative logo-background">
      <div className="absolute flex flex-col left-0">
        <VestelIcon className="w-[171px] h-[171px] object-contain shrink-0 top-4" />
      </div>
      <div className="text-white flex flex-col justify-end ml-[120px] text-center">
        <h2 className="font-league-bold text-2xl leading-tight">
          {t("layout.vestel-smart-world")}
        </h2>
        <p className="font-league font-light mt-1">
          {t("layout.vestel-smart-world-description")}
        </p>
      </div>
    </div>
  );
};

export default MobileLogo;
